import { IStyleProps } from './Interface'
import { makeStyles } from '@material-ui/core/styles'

export default makeStyles<{}, IStyleProps>({
  input: ({ alwaysEnabled }) => ({
    borderRadius: '40px',
    boxSizing: 'border-box',
    backgroundColor: 'white',
    height: '35px',
    fontSize: 12,
    width: '100%',
    ...(alwaysEnabled
      ? {}
      : {
          '& .Mui-disabled': {
            color: 'black',
            cursor: 'text !important'
          },
          '& .MuiOutlinedInput-input': {
            cursor: 'pointer'
          },
          '&:not(:focus-within)': {
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none'
            },
            '& .MuiSvgIcon-root': {
              display: 'none'
            }
          },
          '&:hover:not(:focus-within)': {
            background: '#EDEBEB'
          }
        })
  }),
  searchIcon: {
    fontSize: 18
  },
  display: {
    margin: 0,
    lineHeight: 1,
    borderRadius: 40,
    boxSizing: 'border-box',
    minWidth: 150,
    minHeight: 35,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 15
  },
  hover: {
    '&:hover': {
      background: '#EDEBEB',
      transition: '.3s',
      cursor: 'text'
    }
  },
  autoComplete: {
    width: '100%'
  }
})
